import React from 'react';
import { Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

const MainFooter = () => (
  <footer>
    <Container maxWidth="lg">
      <Grid container>
        <Grid size={12} align="center">
          <Typography>
            Copyright @{new Date().getFullYear()} oneService •  Since 2017
          </Typography>
        </Grid>
      </Grid>
    </Container>
  </footer>
)

export default MainFooter;
